import React from 'react';

const Cart = ({ cart, updateCart }) => {
  const handleRemove = (id) => {
    const updatedCart = cart.filter((item) => item.id !== id);
    updateCart(updatedCart);
  };

  const handleChange = (item, d) => {
    const updatedCart = cart.map((cartItem) =>
      cartItem.id === item.id ? { ...cartItem, amount: cartItem.amount + d } : cartItem
    );

    // Filter out items with amount greater than 0
    const filteredCart = updatedCart.filter((cartItem) => cartItem.amount > 0);
    
    updateCart(filteredCart);
  };

  const calculateTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.amount, 0);
  };

  return (
    <div className="container mt-4 p-3">
      <h2>Cart</h2>
      {cart.length === 0 ? (
        <p className='text-dark'>Your cart is empty.</p>
      ) : (
        <div className='row'>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            {cart.map((item) => (
              <div key={item.id} className="card mb-3">
                <img src={item.img} alt={item.title} className="card-img-top img object-fit-contain p-3" />
                <div className="card-body">
                  <h3 className="card-title text-dark">{item.title}</h3>
                  <p className="card-text text-dark">{item.desc}</p>
                  <p className="card-text text-dark">Price: Rs. {item.price}</p>
                  <p className="card-text text-dark">Amount: {item.amount}</p>
                  <button onClick={() => handleChange(item, -1)} className="btn btn-outline-primary m-2 w-25">
                    -
                  </button>
                  <button className="btn btn-outline-secondary w-25 m-2" >{item.amount}</button>
                  <button onClick={() => handleChange(item, 1)} className="btn btn-outline-primary m-2 w-25">
                    +
                  </button>
                  <button onClick={() => handleRemove(item.id)} className="btn btn-danger ml-1">
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className="mt-3">
              <p className="text-dark">Total Price of your Cart</p>
              <h5 className="text-dark font-weight-bold" style={{color:'green'}}>Rs - {calculateTotal()}</h5>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
